import { AfterViewInit, Component, Inject, OnInit } from "@angular/core";
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';

declare var Swiper: any;

@Component({
    standalone: true,
    selector: 'blog-swiper-component',
    templateUrl: './blog-swiper.component.html',
    styleUrl: './blog-swiper.component.scss',
})
export class BlogSwiperComponent implements AfterViewInit {

    constructor(@Inject(PLATFORM_ID) private platformId: Object) {

    }

    ngAfterViewInit(): void {
        if (isPlatformBrowser(this.platformId)) {
            // Blog slider with automatic infinite (continuous) scrolling
            const blogSwiper = new Swiper(".blog__swiper", {
                spaceBetween: 30,
                slidesPerView: 1.2,
                loop: true,
                loopAdditionalSlides: 6, // helps avoid visible blank when looping
                speed: 6000, // higher = slower continuous movement when delay = 0
                autoplay: {
                    delay: 0, // continuous
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                },
                freeMode: true,
                freeModeMomentum: false, // keeps constant velocity
                grabCursor: false,
                allowTouchMove: true, // still allow manual interaction; set false to fully lock
                breakpoints: {
                    576: {
                        slidesPerView: 2.2
                    },
                    768: {
                        slidesPerView: 2.5
                    },
                    900: {
                        slidesPerView: 3.2
                    }
                }
            });

            var swiper2 = new Swiper(".list__swiper", {
                spaceBetween: 20,
                slidesPerView: 1.5,
                loop: true,
                breakpoints: {
                    576: {
                        slidesPerView: 2.5
                    },
                }
            });
        }

       
    }

}